import { render, staticRenderFns } from "./DualChartContainer.vue?vue&type=template&id=31c3742f&scoped=true&"
import script from "./DualChartContainer.vue?vue&type=script&lang=js&"
export * from "./DualChartContainer.vue?vue&type=script&lang=js&"
import style0 from "./DualChartContainer.vue?vue&type=style&index=0&id=31c3742f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c3742f",
  null
  
)

export default component.exports